import { ChartConfig, ChartContainer, ChartTooltip, ChartTooltipContent } from "@/components/chart";
import { dailyLabelFormatter } from "@/components/chart-template";
import { useRef } from "react";
import { CartesianGrid, Line, LineChart, XAxis, YAxis } from "recharts";
import { ChartData } from "./revenue-data";

const chartConfig = {
  revenue_eur: {
    label: "Revenue €",
    color: "hsl(var(--chart-1))",
  },
} satisfies ChartConfig;

type PerformanceChartProps = {
  chartData: ChartData;
};

function PerformanceChart({ chartData }: PerformanceChartProps) {
  const ref = useRef<HTMLDivElement>(null);

  const labelFormatter = (value: string) => {
    return dailyLabelFormatter(value);
  };

  const data = chartData;
  return (
    <ChartContainer config={chartConfig} ref={ref}>
      <LineChart accessibilityLayer data={data}>
        <CartesianGrid vertical={false} />
        <XAxis dataKey="dateTime" tickLine={false} axisLine={false} tickMargin={8} tickFormatter={labelFormatter} />
        <YAxis
          dataKey="revenue_eur"
          tickLine={false}
          axisLine={false}
          tickMargin={8}
          tickFormatter={(value: number) => {
            return "€" + value;
          }}
        />
        <ChartTooltip
          cursor={false}
          content={<ChartTooltipContent nameKey="revenue_eur" labelFormatter={labelFormatter} />}
        />
        <Line dataKey="revenue_eur" type="linear" stroke="var(--color-revenue_eur)" strokeWidth={2} dot={false} />
      </LineChart>
    </ChartContainer>
  );
}

export default PerformanceChart;
